var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24775 7.63991L0.451518 2.1585C-0.114242 1.51192 0.344935 0.5 1.20409 0.5H10.7966C11.6557 0.5 12.1149 1.51192 11.5491 2.1585L6.7529 7.63991C6.35449 8.09524 5.64616 8.09524 5.24775 7.63991Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArowBlue);
export default __webpack_public_path__ + "static/media/dropdown-arow-blue.2b048bf493d5ad412ebd747aa47ef5ef.svg";
export { ForwardRef as ReactComponent };